module.exports = __webpack_public_path__ + "img/c-1.1465e90c.jpg";